import styled from 'styled-components'
import { blue, orange } from '../../styles/colors'
import breakpoints from '../../styles/breakpoints'

export const FooterSocial = styled.section`
  @media (min-width: ${breakpoints.md}) {
    display: flex;
  }
`

export const Social = styled.ul` 
  @media (min-width: ${breakpoints.md}) {
    margin-right: 80px;
  }
  li {
    float: left;
    margin-right: 10px;  
      a {
        &:hover {
        fill: ${orange['medium']} !important;
      }  
    }
  }
`

export const AnyQuestions = styled.div`
  p {
    font-size: 10px;
    a {
      text-decoration: underline;
      color: #161616;
    }
  }
`

export const FooterMenu = styled.ul`
  li {
    font-size: 10px;
    margin-right: 10px;
    float: left;
    a {
        color: ${blue['900']};
        float: left;
        &:hover {
          color: ${orange['medium']}
        }
    }
  }
`

export const FooterAdress = styled.div`
  float: left;
  p {
    font-size: 10px;
  }
`